/** Ayrical roles in Ayrical's display order. */
export const AYRICAL_ACCESS_ROLES = [
    'admin',
    'manager',
    'finance',
    'sales',
    'tech',
    'viewer',
];
export const AYRICAL_ACCESS_ROLE_LABELS = {
    admin: 'Admin',
    manager: 'Manager',
    finance: 'Finance',
    sales: 'Sales',
    tech: 'Tech',
    viewer: 'Viewer',
};
/** Why a membership is suspended or reactivated; Ayrical requires one. */
export const MEMBER_STATUS_REASON_OPTIONS = [
    { value: 'offboarding', label: 'Offboarding' },
    { value: 'leave', label: 'Leave' },
    { value: 'role_change', label: 'Role change' },
    { value: 'other', label: 'Other' },
];
export function isAyricalAccessRole(value) {
    return AYRICAL_ACCESS_ROLES.includes(value);
}
export function isMemberStatusReason(value) {
    return MEMBER_STATUS_REASON_OPTIONS.some((option) => option.value === value);
}
/**
 * A member's Ayrical role: the server's `access_role` when present, else the
 * tickets role it maps from (both Tech values are `tech`).
 */
export function accessRoleOf(member) {
    if (member.accessRole && isAyricalAccessRole(member.accessRole))
        return member.accessRole;
    if (member.role === 'technician' || member.role === 'lead_tech')
        return 'tech';
    return member.role && isAyricalAccessRole(member.role) ? member.role : null;
}
/** Ids that identify the signed-in user on a member record (user id). */
export function isSelfMember(member, self) {
    if (!self)
        return false;
    return Boolean(member.id) && (member.id === self.id || member.id === self.memberUuid);
}
/**
 * Whether the signed-in user may change this member's role or access: the
 * access check must have loaded, the server must mark the member manageable,
 * and nobody manages themselves.
 */
export function canManageMember(member, access, self) {
    return Boolean(access) && member.canManage === true && !isSelfMember(member, self);
}
/**
 * Role choices for a manageable member: the roles the actor may grant, plus
 * the member's current role (shown as the selected value even when the actor
 * could not grant it), in Ayrical's display order.
 */
export function memberRoleOptions(current, grantable) {
    return AYRICAL_ACCESS_ROLES.filter((role) => role === current || grantable.includes(role));
}
/**
 * What the admin UI (web and mobile) offers for one member. Role changes are
 * for active members only; pending members are handled as invitations; a
 * role select that could only re-pick the current role is not offered.
 */
export function memberManagementChoices(member, currentRole, access, self) {
    if (!access || !canManageMember(member, access, self))
        return { roleOptions: [], statusAction: null };
    const status = member.status ?? 'active';
    const options = status === 'active' ? memberRoleOptions(currentRole, access.grantableRoles) : [];
    return {
        roleOptions: options.some((role) => role !== currentRole) ? options : [],
        statusAction: status === 'active' ? 'suspend' : status === 'suspended' ? 'reactivate' : null,
    };
}
//# sourceMappingURL=memberAccess.js.map